import axiosInstance from "./axiosInstance.ts";

export interface PublicConfigResponse {
    featureFlags: Record<string, boolean>;
}

/**
 * Fetch public frontend config (feature flags). Public endpoint — works with or
 * without auth. Errors propagate; the context falls back to fail-closed defaults.
 */
export const getPublicConfig = async (): Promise<PublicConfigResponse> => {
    const response = await axiosInstance.get<PublicConfigResponse>('/config');
    return response.data;
};
